import React from 'react';
import { Icon } from '@chakra-ui/react';

function CheckCircle(props) {
  return (
    <Icon viewBox="0 0 18 18" fill="none" {...props}>
      <circle
        cx="9"
        cy="9"
        r="8"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1271 6.60317C13.3 6.76685 13.3 7.04208 13.1271 7.20575L8.89361 11.2147C8.72696 11.3725 8.45677 11.3725 8.29013 11.2147L5.76349 8.82208C5.59064 8.6584 5.59064 8.38317 5.76349 8.2195C5.92351 8.06796 6.17407 8.06796 6.33409 8.2195L8.59187 10.3575L12.5565 6.60317C12.7166 6.45164 12.9671 6.45164 13.1271 6.60317Z"
        fill="currentColor"
      />
    </Icon>
  );
}

export default CheckCircle;
